module.exports = __webpack_public_path__ + "img/birthday.d8b53085.png";